// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3SMVz","empty":"ModalGraph_empty__3OlHZ"};